'use strict'
const intersectViewport = {

	fxCheckInViewport(element, callback, threshold	= 1) {

		const observer = new IntersectionObserver(callback, { threshold: threshold })

		if (element instanceof Element) 
			observer.observe(element)
		
		else 
			for (const el of element)
				observer.observe(el)
	}
}

//How to use in another page

// const callback = entries => {
// 	for (const entry of entries) {
// 		const el = entry.target
// 		if (entry.isIntersecting && !el.classList.contains('is-visible')) {
//			SOME CODE HERE
// 			el.classList.add('is-visible')
// 		}
//	}
//}
// IF MULTIPLE ELEMENTS intersectViewport.fxCheckInViewport(document.querySelectorAll('nodes'), callback)
// IF SINGLE ELEMENTS   intersectViewport.fxCheckInViewport(document.querySelector('element'), callback)